import { AssignAllProspectsQueryParams } from '../../../components/pages/connected/Dashboard/DashboardCommerciaux/AssignProspectsModal/AssignProspectsTable/AssignProspectsTable.types';
import { UpdateProspectStatusQueryParams } from '../../../components/pages/connected/Dashboard/DashboardProspects/DashboardProspectsTable/DashboardProspectsTable.types';
import { AssignProspectQueryParams } from '../../../components/pages/connected/Dashboard/DashboardProspectsDIR/DashboardProspectsDIRAssignModal/DashboardProspectsDIRAssignTable/DashboardProspectsDIRAssignTable.types';
import { UsePendingProspectParams } from '../../../hooks/fetchers/usePendingProspect/usePendingProspect.types';
import { UseProspectsQueryParams } from '../../../hooks/fetchers/useProspects/useProspects.types';
import { PageQueryParams } from '../../../types/api/api.types';
import { CreateAccountManuallyRequestData, CreateProspectDIRRequestData, CreateProspectRequestData } from '../../../types/api/endpoints/prospect/create.types';
import {
  GetProspectsFromDIRQueryParams,
  UpdateStatusProspectWithCommentRequestData,
} from '../../../types/api/endpoints/prospect/prospect.types';
import {
  StaticGetEndpoints,
  StaticPostEndpoints,
} from '../../../types/api/endpoints/staticEndpoints';
import { api } from '../api';

export const PROSPECT_ENDPOINTS = Object.freeze({
  create: (data: CreateProspectRequestData) => api.post(StaticPostEndpoints.CreateProspect, data),
  createProspectManually: (data: CreateAccountManuallyRequestData) => api.post(StaticPostEndpoints.CreateAccountFromProspect, data),
  createProspectFromDIR: (data: CreateProspectDIRRequestData) => api.post(StaticPostEndpoints.CreateProspectFromDIR, data),

  getStatusHistory: (prospectId: number) =>
    api.get(`prospect/${prospectId}/status/history`),
  updateStatus: (data: UpdateProspectStatusQueryParams) =>
    api.put(StaticPostEndpoints.UpdateProspectStatus, data),
  updateStatusWithComment: (data: UpdateStatusProspectWithCommentRequestData) =>
    api.put(StaticPostEndpoints.UpdateProspectStatusWithComment, data),
  sendEmail: (prospectId: number) =>
    api.post(StaticPostEndpoints.SendEmailProspect, { prospectId }),
  assignProspect: (data: AssignProspectQueryParams) =>
    api.put(StaticPostEndpoints.AssignProspect, data),
  assignAllProspects: (data: AssignAllProspectsQueryParams) =>
    api.put(StaticPostEndpoints.AssignAllProspects, data),
  assignFromExcel: (data: FormData) =>
    api.post(StaticPostEndpoints.AssignFromExcel, data),

  getAll: (params: UseProspectsQueryParams) => api.get(StaticGetEndpoints.AllCOMProspects, params),
  getAllDIR: (params: PageQueryParams) => api.get(StaticGetEndpoints.AllDIRProspects, params),

  getAllFromCOM: (params: PageQueryParams) => api.get(StaticGetEndpoints.AllCOMProspects, params),
  searchFromCOM: (search: string, params: PageQueryParams) =>
    api.get(`prospect/COM/${search}`, params),

  getAllFromDIR: (params: GetProspectsFromDIRQueryParams) =>
    api.get(StaticGetEndpoints.AllDIRProspects, {
      ...params,
      commercialIds: params.commercialIds || undefined,
    }),
  searchFromDIR: (search: string, params: GetProspectsFromDIRQueryParams) =>
    api.get(`prospect/DIR/${search}`, {
      ...params,
      commercialIds: params.commercialIds || undefined,
    }),

  pending: (params: UsePendingProspectParams) =>
    api.get(StaticGetEndpoints.PendingProspects, params),

  search: (search: string) => api.get(`prospect/search/${search}`),
  searchCurrentCOM: (search: string) => api.get(`prospect/search/currentCOM/${search}`),
  directory: (search: string) => api.get(`prospect/directory/${search}`),
});
